import React from "react"
import { StaticNavigation, ConsistentlyProvider, classnames } from "@fastly/consistently-vanilla"
import { themeDocumentation } from "@fastly/consistently-vanilla/tokens"

import { stickyProvider } from "./Header.css"

export const Header = () => {
  return (
    <ConsistentlyProvider reset theme={classnames([stickyProvider, themeDocumentation])}>
      {/*
        We wrap the navigation in a provider to scope the CSS reset, which breaks `position: sticky`
        on the nav. Therefore, we pass a new class via the `theme` prop (hack).
      */}
      <StaticNavigation />
    </ConsistentlyProvider>
  )
}
